export default __webpack_public_path__ + "static/media/fnoche.d7a35349.svg";